import styled from 'styled-components';
import {
  fullChartWidth,
  highChartYAxistWidth,
  marginBottom,
} from '../../containers/MeasuresContext/utils/constants';

export const MainWrap = styled.div`
  color: ${(props) => props.theme.palette.text.primary};
`;
export const MainGraph = styled.div<{
  isScores?: boolean;
}>`
  display: flex;
  ${(props: any) => (props.isScores ? `flex-direction: column;` : `;`)}
  width: 100%;
  justify-content: center;
  padding-top: 10px;
  padding-bottom: 10px;
`;

export const StyledScoresUIDiv = styled.div`
  padding-left: 2%;
  display: flex;
  flex-direction: column;
`;
// overflow hidden ag-grid react with display flex

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-right: 0.25rem;
`;

export const ScoreName = styled.span`
  font-size: 0.93rem;
`;
export const ScoreNameFocused = styled.span`
  font-size: 0.93rem;
  cursor: pointer;
`;

// margin-left for small widget display so that it is not stuck to the border
const nameMarginLeft = 10;
export const SparklineDiv = styled.div<{
  height?: number;
}>`
  display: flex;
  align-items: center;
  margin-left: ${nameMarginLeft}px;
  ${(props: any) => (props.height ? `height: ${props.height}px;` : `;`)}
`;
export const NotCountWrapper = styled.div`
  width: 20px;
`;
export const ScoresNameDiv = styled.div<{
  height?: number;
  color?: string;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 39px;
  margin-right: 9px;
  padding: 3px;
  width: 100%;
  justify-content: space-between;
  color: ${(props) => props.theme.palette.text.primary};
  box-sizing: border-box;
  ${(props: any) => `border-top: 2px solid ${props.color};
                     border-bottom: 1px solid ${props.color};
                     border-right: 2px solid ${props.color};
                     border-left: 2px solid ${props.color};`}
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
  }
`;

const nameMinWidth = 100;
export const MeasureNameDiv = styled.div<{
  smallWidget?: boolean;
  showScoreForm?: boolean;
  color?: string;
  print?: boolean;
}>`
  ${(props: any) =>
    props.smallWidget
      ? `min-width: 85px; margin-left: 10px;`
      : `min-width: ${nameMinWidth}px;`}
  ${(props: any) =>
    props.smallWidget || props.showScoreForm ? `;` : `cursor: pointer;`}
  ${(props: any) => (props.color ? `color: ${props.color};` : ';')}
  ${(props: any) => (props.print ? `width: 65px;` : `;`)}
  justify-content: center;
  @media (max-width: 600px) {
    min-width: 0;
    width: 100%;
    margin-left: 0;
    text-align: left;
    align-self: stretch;
  }
`;

export const MeasuresTableWrapper = styled.div<{
  width?: number;
  height?: number;
}>`
  ${(props: any) => (props.width ? `width: ${props.width}px;` : `;`)}
  ${(props: any) =>
    props.height ? `height: ${props.height}px;` : `;`}
  border: 1px solid black;
`;

export const NotFoundWrapper = styled.div`
  ${(props: any) => {
    const { smallWidgetHeight } = props.theme.props.dashboard;
    return `height: ${smallWidgetHeight}px;
            min-height: ${smallWidgetHeight}px;`;
  }}
  display: flex;
  flex-direction: column;
  border: 2px solid ${(props) => props.theme.palette.background.paper};
  overflow: scroll;
  align-items: center;
  background-color: ${(props) => props.theme.palette.background.paper};
  position: relative;
`;

// 98% as it should not fill up all the entire space
const graphWidth = fullChartWidth * 100;
// when resizing the window would need this width: calc(95vw - 270px)
// issue with ScoresNameDiv margin-right of 9px
// props.openMeasures
// ? `width: calc(95vw - 270px);`
// : `width: ${graphWidth}%;`}
export const MeasuresWrapper = styled.div<{
  smallWidget?: boolean;
  openMeasures?: boolean;
  print?: boolean;
}>`
  display: flex;
  ${(props: any) =>
    // eslint-disable-next-line no-nested-ternary
    props.smallWidget ? `width: 100%;` : `width: ${graphWidth}%;`}
  ${(props: any) =>
    props.print
      ? `width: 750px;
         margin-left: auto;
         margin-right: auto;`
      : ';'}
`;
// props print last as overriding above width rules
export const GoBackDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  width: ${graphWidth}%;
  padding-left: 5%;
`;

export const MeasuresTableDiv = styled.div`
  margin-top: 5px;
  margin-left: ${highChartYAxistWidth + 10}px;
  margin-right: 20px;
`;

// so that high chart library gets it
export const ChartWrapper = styled.div`
  width: 100%;
`;

export const NamesWrapper = styled.div<{
  print?: boolean;
}>`
  ${(props: any) => (props.print ? `width: 65px;` : ';')}
  color: ${(props) => props.theme.palette.text.primary};
`;

export const MeasureSparkLineWrapper = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
`;

export const CellDiv = styled.div`
  display: flex;
  align-items: center;
`;

export const MeasureValue = styled.span``;

export const UnitsValue = styled.span`
  padding-left: 5px;
`;
export const MeasureDescription = styled.span`
  font-style: italic;
`;
export const EnterCell = styled.span<{ width: string }>`
  display: block;
  cursor: pointer;
  width: ${(props) => props.width}px;
`;
export const MeasureCell = styled.div<{ width: string }>`
  width: ${(props) => props.width}px;
`;
export const MeasureCellScrollable = styled.div<{ width: string }>`
  width: ${(props) => props.width}px;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  line-height: 1.35;
  white-space: normal;
  box-sizing: border-box;
`;
export const PrintMeasureCell = styled.div<{ width: string }>`
  width: ${(props) => props.width}px;
  display: flex;
  justify-content: center;
`;
export const MeasuresPrintDiv = styled.div`
  background-color: ${(props) => props.theme.palette.background.paper};
  color: ${(props) => props.theme.palette.text.primary};
  @media print {
    page-break-after: always;
    color: ${(props) => props.theme.palette.common.black};
    background-color: ${(props) => props.theme.palette.common.white};
  }
`;
export const PageBreak = styled.div`
  @media print {
    visibility: hidden;
  }
`;

export const NoMeasuresDiv = styled.div`
  display: flex;
  align-self: flex-start;
  margin-left: 1em;
  color: ${(props) => props.theme.palette.text.primary};
`;
export const TablePrintDiv = styled.div`
  margin-top: 5px;
  margin-bottom: 5px;
`;
export const PrintTextDiv = styled.div`
  display: flex;
  justify-content: center;
  font-size: 1em;
  letter-spacing: 0.0625em;
  font-weight: normal;
  text-transform: uppercase;
  padding: 10px 0px;
`;

export const ChartNameWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${marginBottom}px;
`;

export const NonGraphableHistoryPreview = styled.div<{
  chartHeight: number;
  border?: string;
  marginLeft?: number;
  /** Small widget: allow ~2 lines per value instead of single-line ellipsis. */
  allowWrap?: boolean;
}>`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: ${(props) => props.chartHeight}px;
  margin-left: ${(props) => props.marginLeft ?? 60}px;
  border: 2px solid ${(props) => props.border || 'transparent'};
  padding: 4px 8px;
  overflow: hidden;
  font-size: 12px;
  line-height: 1.35;
  color: ${(props) => props.theme.palette.text.primary};

  .preview-row {
    display: flex;
    gap: 8px;
    padding: 2px 0;
    min-height: 0;
  }

  .preview-date {
    flex-shrink: 0;
    white-space: nowrap;
  }

  .preview-value {
    flex: 1;
    overflow: hidden;
    ${(props) =>
      props.allowWrap
        ? `
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      white-space: normal;
      word-break: break-word;
    `
        : `
      text-overflow: ellipsis;
      white-space: nowrap;
    `}
  }

  .preview-more {
    margin-top: auto;
    padding-top: 2px;
    text-align: center;
    color: ${(props) => props.theme.palette.text.secondary};
  }

  .preview-empty {
    color: ${(props) => props.theme.palette.text.secondary};
  }
`;

export const ScoresNumber = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 50%;
  flex-wrap: wrap;
  @media (max-width: 600px) {
    width: 100%;
    justify-content: center;
    box-sizing: border-box;
  }
`;

/** Narrow view: two rows 0–5 and 6–10 (eleven score buttons) */
export const ScoresNumberPhoneStack = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  gap: 6px;
  box-sizing: border-box;
`;
export const ScoresNumberRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;
  width: 100%;
  box-sizing: border-box;
`;
export const ScoresMethodsDiv = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 30px;
  margin-left: 50px;
  margin-bottom: 20px;
  @media (max-width: 600px) {
    flex-direction: column;
    margin-left: 8px;
    margin-right: 8px;
  }
`;

export const MethodButtonsDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 10px;
  width: 100%;
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
    box-sizing: border-box;
  }
`;

export const SubmitHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const DividerDiv = styled.div`
  margin-top: 10px;
  margin-left: ${highChartYAxistWidth}px;
  margin-right: 5px;
`;

export const DividerSummaryDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const DividerActionDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
/**
 *  FORM SCORES
 */
export const SubmitVitalsDiv = styled.div`
  margin-top: '2%';
  display: flex;
  justify-content: space-evenly;
  align-items: center;
`;

export const InputContainer = styled.div`
  > * [class*='MuiInputBase-input'] {
    background-color: transparent;
    font-size: 13px;
    box-sizing: initial;
  }
`;

export const CalendarDiv = styled.div`
  padding: 5px;
  > * [class*='MuiButtonBase'] {
    padding: 0 !important;
  }
  > * [class*='MuiInputBase-input'] {
    font-size: 13px;
    text-align: center;
    box-sizing: initial;
  }
`;

export const borderlessButtonStyle = {
  outline: 'transparent',
  background: 'transparent',
  padding: '0px',
};
